import React from "react";
import {CreateLinguisticValue} from "./CreateLinguisticValue";

export class MissingLinguisticValue extends CreateLinguisticValue {

    componentDidMount() {
        this.setState({
            values: [],
            key: this.dictionary.fetchEmptyKey(),
            namespace: 'frontend'
        });
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        (document.querySelector('form .alert.alert-success') as HTMLElement).classList.remove('hide');
    }
}